@if (dataContext) {
  <form class="action-form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <h1 class="title">{{ 'COOPERATIVE_HOUSING.KU55.REGENERATE_CONTROL_DATA_LABEL' | translate }}</h1>
    <div class="row">
      <p class="col-12 help-text">{{ 'COOPERATIVE_HOUSING.KU55.REGENERATE_CONTROL_DATA_DESCRIPTION' | translate }}</p>
    </div>
    <section>
      <div class="d-flex justify-content-center">
        <button class="btn btn-active" type="submit">OK</button>
        <button class="btn link-btn ml-2" (click)="cancel()">{{ 'CANCEL_BTN' | translate }}</button>
      </div>
    </section>
  </form>
}
